module.exports = __webpack_public_path__ + "static/media/logo.1d19426f.svg";